import styled from 'styled-components'
import { Text, Flex, Heading, IconButton, ArrowBackIcon, NotificationDot, QuestionHelper } from '@pancakeswap/uikit'
import { useExpertModeManager } from 'state/user/hooks'
import GlobalSettings from 'components/Menu/GlobalSettings'
import Link from 'next/link'
import useTheme from 'hooks/useTheme'
import { palette } from 'views/Home/colors'
import Transactions from './Transactions'
import { SettingsMode } from '../Menu/GlobalSettings/types'

interface Props {
  title: string
  subtitle?: string
  helper?: string
  backTo?: string | (() => void)
  noConfig?: boolean
}

const AppHeaderContainer = styled(Flex)<{ $border: string }>`
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  width: 100%;
  border-bottom: 1px solid ${({ $border }) => $border};
`

const AppHeader: React.FC<React.PropsWithChildren<Props>> = ({ title, subtitle, helper, backTo, noConfig = false }) => {
  const [expertMode] = useExpertModeManager()
  const { theme } = useTheme()
  const p = palette(theme.isDark)

  return (
    <AppHeaderContainer $border={p.border}>
      <Flex alignItems="center" width="100%" style={{ gap: '12px' }}>
        {backTo &&
          (typeof backTo === 'string' ? (
            <Link passHref href={backTo} prefetch={false}>
              <IconButton as="a" scale="sm" variant="text">
                <ArrowBackIcon width="24px" color={p.fg} />
              </IconButton>
            </Link>
          ) : (
            <IconButton scale="sm" variant="text" onClick={backTo}>
              <ArrowBackIcon width="24px" color={p.fg} />
            </IconButton>
          ))}
        <Flex flexDirection="column" width="100%">
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center" style={{ gap: 6 }}>
              <Heading as="h2" style={{ fontSize: 18, fontWeight: 700, color: p.fg, letterSpacing: '-0.3px' }}>
                {title}
              </Heading>
              {helper && <QuestionHelper text={helper} ml="4px" placement="top-start" />}
            </Flex>
            {!noConfig && (
              <Flex alignItems="center" style={{ gap: 4 }}>
                <NotificationDot show={expertMode}>
                  <GlobalSettings mode={SettingsMode.SWAP_LIQUIDITY} />
                </NotificationDot>
                <Transactions />
              </Flex>
            )}
          </Flex>
          {subtitle && (
            <Text color={p.fgSecondary} fontSize="12px" mt="2px">
              {subtitle}
            </Text>
          )}
        </Flex>
      </Flex>
    </AppHeaderContainer>
  )
}

export default AppHeader
